import React from 'react'
import log from 'lib/log'
import AsyncPage from 'pages/AsyncPage'
import {
  loadFilteredPosts, loadInterestingPosts,
  loadFilteredEvents, loadInterestingEvents,
  suggestPosts
} from 'state/actions/posts'
import universal from 'react-universal-component'
const component = universal(props => import('./HomeNewsPage'))
import HomePostsExtraNav from './HomePostsExtraNav'
import { get_query } from 'lib/search_util'

const pathname = typeof window !== "undefined" && location.pathname 
let firstVisitRedirect = pathname === "/" || pathname === "/welcome"
const isFirstVisit = () => {
  if (typeof window === "undefined") {
    return true
  }
  const fistVisit = !firstVisitRedirect
  firstVisitRedirect = true
  return fistVisit
}
class AsyncHomeNewsPage extends AsyncPage {
  loadInteresting: any
  suggestPosts: any
  constructor() {
    super({
      pageComponent: component
    })
    this.loadFiltered = suggestPosts
    this.loadInteresting = loadInterestingPosts
    this.nonav = true
  }

  async prepareAdditionalAsyncData(dispatch, getState, opts) {
    // let { navigation: { stack } } = getState()
    // let search = get_query(stack)
    // if (search) {
    //   try {
    //     await this.loadFiltered({ filter: search })(dispatch, getState, opts)
    //   } catch (e) {
    //     log.error(e)
    //   }
    //   return
    // }

    // const { session: { value: profile } } = getState()
    // if (!profile && !this.eventsPage && isFirstVisit()) {
    //   // not logged-in, need to load something interesting for
    //   // guest users, or redirect to the welcome screen
    //   await dispatch({
    //     type: 'home/welcome'
    //   })
    //   return
    // }

    // try {
    //   await this.loadInteresting({})(dispatch, getState, opts)
    // } catch (e) {
    //   log.error(e)
    // }

  }
  getExtraSecondaryNavigation() {
    return <HomePostsExtraNav key={Date.now() + '_'} />
  }
}

class AsyncHomeEvents extends AsyncHomeNewsPage {

  constructor() {
    super({
      pageComponent: component
    })
    this.eventsPage = true
    this.loadFiltered = loadFilteredEvents
    this.loadInteresting = loadInterestingEvents
  }
}

export const AsyncHomeEventsPage = new AsyncHomeEvents()

export default new AsyncHomeNewsPage()
